
import React from 'react'
const CrmPlaceHolder = () => (
    <div style={{'width':'100%'}}/>
)
export default CrmPlaceHolder